import React, { Dispatch, useEffect, useState, useRef } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import Typography from '@material-ui/core/Typography';
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { MenuProps } from '@material-ui/core/Menu';
import { withStyles } from "@material-ui/core/styles";
import { getBillingDetails } from "../../store/actions/delivery.actions";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { useHistory } from "react-router-dom";
import ListItemText from '@material-ui/core/ListItemText';
import Snackbar from "../../common/components/CreatedEnquirySnackbar";
import FullscreenLoader from "./../../common/components/FullscreenLoader";
import moment from "moment-timezone";
import NotificationIcon from "../../common/components/NotificationIcon";
import TextField from "@material-ui/core/TextField";
import IconButton from "@material-ui/core/IconButton";
import Paper from "@material-ui/core/Paper";
import Tooltip from "@material-ui/core/Tooltip";
import _, { get } from "lodash";
import AnnouncementIcon from "../../common/components/AnnouncementIcon";
import DatePicker from "../../common/components/dateRangePicker";
import GetAppIcon from '@material-ui/icons/GetApp';
import { deliveryService } from "../../services/delivery.service";
import Menu from '@material-ui/core/Menu';
import { getFSECustomerList } from "../../store/actions/dealer.action";
import MenuItem from '@material-ui/core/MenuItem';
import {
    Button,
    Grid,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    InputLabel,
    Select,
    Box
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import InputAdornment from "@material-ui/core/InputAdornment";
import { getListOfDownloadInvoiceAPI } from "../../store/actions/delivery.actions";
import { useDispatch, useSelector } from "react-redux";
import { getCustomerFilterOptions } from "../../common/components/util";
import CloseIcon from '@material-ui/icons/Close';


const useStyles = makeStyles(() => ({
    root: {
        width: "100%",
    },
    actionButtons: {
        display: "flex",
        gap: 16,
        marginTop: 24,
        marginBottom: 24,
    },
    actionButton: {
        color: "#1A9FE0",
    },
    invoiceHeader: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
    },
    invoiceInfo: {
        display: "flex",
        flexDirection: "row",
        gap: 10,
        flexWrap: "nowrap",
        whiteSpace: "nowrap",
    },
    pageSub: {
        fontWeight: 800,
        color: "#000000",
        fontSize: "0.875rem",
        margin: 0,
    },
    invoiceId: {
        fontSize: "1.125rem",
        fontWeight: 700,
        fontFamily: "Nunito",
        color: "#1a1a1a",
        margin: 0,
    },
    invoiceDate: {
        fontSize: "0.875rem",
        fontFamily: "Nunito",
        color: "#666666",
        margin: 0,
        paddingTop: 6,
    },
    headerActions: {
        display: "flex",
        gap: 10,
        alignItems: "center",
        justifyContent: "flex-end",
    },
    checkboxFix: {
        paddingLeft: "8px",
        display: "inline-flex",
        alignItems: "center",
        fontFamily: "Nunito",
        whiteSpace: "nowrap",
        fontWeight: 600,
        fontSize: "0.813rem",
        color: "#444444",
    },
    tableContainer: {
        backgroundColor: "#ffffff",
        borderRadius: 8,
        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
    },
    tableHeadSmall: {
        color: '#133F8A',
        fontWeight: 900,
        fontSize: '0.75rem',
        fontFamily: 'Nunito',
        borderBottom: "2px solid #e0e0e0",
        padding: 10,
        lineHeight: 0,
        width: 40,
    },
    tableHeadSmall1: {
        color: '#133F8A',
        fontWeight: 900,
        fontSize: '0.75rem',
        fontFamily: 'Nunito',
        paddingLeft: 20,
        lineHeight: 0,
        width: 40,
    },
    tableHeader: {
        backgroundColor: "#ffffff",
    },
    headerCell: {
        color: "#133F8A",
        fontWeight: 900,
        fontSize: "0.75rem",
        textAlign: "left",
        fontFamily: "Nunito",
        borderBottom: "2px solid #e0e0e0",
        padding: "8px",
        whiteSpace: "nowrap",
    },
    bodyCell: {
        whiteSpace: "nowrap",
        padding: "10px",
    },
    subHeaderText: {
        fontSize: "0.75rem",
        fontFamily: "Nunito",
        fontWeight: 600,
        color: "#161212ff",
        marginTop: 4,
    },
    subHeaderText1: {
        fontSize: "0.65rem",
        fontFamily: "Nunito",
        fontWeight: 500,
        color: "rgb(109, 106, 106)",
        marginTop: 3,
    },
    iframeContainer: {
        width: "100%",
        height: "70vh",
        border: "none",
        backgroundColor: "#fff",
    },
}));



export default function DownloadInvoice() {
    const history = useHistory();
    const [customerAnchorEl, setCustomerAnchorEl] = useState<null | HTMLElement>(null);
    const [selectedCustomerId, setSelectedCustomerId] = useState("");
    const [searchTextByID, setSearchTextByID] = useState("");
    const [customerId, setCustomerId] = useState<any[]>([]);
    const { getFSECustomerListData }: any = useSelector((state: any) => state.dealer);
    const classes = useStyles();
    const dispatch: Dispatch<any> = useDispatch();
    const [loading, setLoading] = React.useState<any>(false);
    const [showErrorMessage, setShowErrorMessage] = React.useState<any>(null);
    const [successMessage, setSuccessMessage] = React.useState<any>(null);
    const [openSnackbar, setOpenSnackbar] = React.useState(false);
    const [openErrorSnackbar, setOpenErrorSnackbar] = React.useState(false);
    const [returnOrderList, setReturnOrderList] = useState<any[]>([]);
    const [openPdfViewer, setOpenPdfViewer] = useState<boolean>(false);
    const [invoiceSearch, setInvoiceSearch] = useState("");
    const [paymentStatus, setPaymentStatus] = useState("All");
    const [salesOrderSearch, setSalesOrderSearch] = useState("");
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [selectedBillingDocument, setSelectedBillingDocument] = useState<string>("");
    const [filterByCustomer, setFilterByCustomer] = React.useState(sessionStorage.getItem('userType') === 'sre' ? "All" : '');
    const [selectedCustomerName, setSelectedCustomerName] = React.useState<any>('');
    const [selectedSalesOrder, setSelectedSalesOrder] = useState<string>("");

    const handleClick = (event: React.MouseEvent<HTMLElement>, billingDocument: string, salesOrder: string) => {
        setSelectedBillingDocument(billingDocument);
        setSelectedSalesOrder(salesOrder);
        setAnchorEl(event.currentTarget); // HTMLElement ✔️
    };

    const handleClose = () => {
        setAnchorEl(null);
    };


    const [htmlContent, setHtmlContent] = React.useState<string>("");
    const iframeRef = useRef<HTMLIFrameElement>(null);
    const [isResetTriggered, setIsResetTriggered] = useState(false);
    const [allCustomers, setAllCustomers] = useState<any[]>([]);

    // Ref-based guard so a fast double-click / re-render can't start a second
    // parallel export call.
    const excelExportInFlightRef = useRef(false);

    const exportExcel = async (billingDocument: string, salesDocument: string) => {
        // Single API call only. Whatever downloadExcel returns (success/error,
        // message, data/url) is what we show and act on — no polling, no
        // retries, no hardcoded messages.
        if (excelExportInFlightRef.current) {
            console.log("exportExcel -> export already in progress, skipping duplicate call");
            return;
        }
        excelExportInFlightRef.current = true;

        const sessionDetails = {
            webApplicationLoginId: webApplicationLoginId,
            clientIPAddress: sessionStorage.getItem('clientIp'),
        };

        const payload = {
            invoiceNumber: billingDocument || "",
            orderNumber: salesDocument || "",
            sessionDetails,
        };

        try {
            const res = await deliveryService.downloadExcel(payload);

            if (res?.success === false || res?.message?.status === "E") {
                setOpenErrorSnackbar(true);
                handleopenCloseErrorSnackbar(true);
                setShowErrorMessage(
                    res?.error || res?.message?.message || "Something went wrong"
                );
                return;
            }

            if (res?.message?.status === "S") {
                await exportData(billingDocument, 'excel', salesDocument, 0);
            } else {
                setOpenErrorSnackbar(true);
                handleopenCloseErrorSnackbar(true);
                setShowErrorMessage(
                    res?.error || res?.message?.message || "Something went wrong"
                );
            }
        } catch (error: any) {
            setOpenErrorSnackbar(true);
            handleopenCloseErrorSnackbar(true);
            setShowErrorMessage(error?.message || "Something went wrong");
        } finally {
            excelExportInFlightRef.current = false;
        }
    };

    const exportData = async (
        billingDocument: string,
        format: "pdf" | "excel",
        salesDocument: string,
        retryCount: number = 0
    ) => {
        const orgId = 2195;
        const MAX_RETRIES = 5;

        try {
            const res = await deliveryService.downloadInvoice(billingDocument, orgId, 'searchByInvoice');
            if (res.success === false) {
                setOpenErrorSnackbar(true);
                handleopenCloseErrorSnackbar(true);
                setShowErrorMessage(
                    res?.error || res?.message?.message || "Something went wrong"
                );
                if (format === "excel") excelExportInFlightRef.current = false;
                return;
            }

            if (res?.message?.status === "S") {
                const files = Array.isArray(res?.data) ? res.data : [res.data];

                const pdfFile = files.find((f: any) => f.url?.endsWith(".pdf"));
                const excelFile = files.find((f: any) => f.url?.endsWith(".xls"));

                if (format === "excel") {
                    if (excelFile) {
                        window.open(excelFile.url);
                        setOpenErrorSnackbar(false);
                        handleopenCloseErrorSnackbar(false);
                        setShowErrorMessage(null);
                        setSuccessMessage(res?.message?.message || "Invoice data fetched successfully");
                        setOpenSnackbar(true);
                        handleopenCloseSnackbar(true);
                        excelExportInFlightRef.current = false;
                    } else if (retryCount < MAX_RETRIES) {
                        setTimeout(() => {
                            exportData(billingDocument, "excel", salesDocument, retryCount + 1);
                        }, 2000);
                    } else {
                        setOpenErrorSnackbar(true);
                        handleopenCloseErrorSnackbar(true);
                        setShowErrorMessage("Excel file is taking longer than expected. Please try again shortly.");
                        excelExportInFlightRef.current = false;
                    }
                }

                if (format === "pdf") {
                    if (pdfFile) {
                        window.open(pdfFile.url);
                        setOpenErrorSnackbar(false);
                        handleopenCloseErrorSnackbar(false);
                        setShowErrorMessage(null);
                        setSuccessMessage(res?.message?.message || "Invoice data fetched successfully");
                        setOpenSnackbar(true);
                        handleopenCloseSnackbar(true);
                    }
                }
            } else if (res?.message?.status === "E") {
                setOpenErrorSnackbar(true);
                handleopenCloseErrorSnackbar(true);
                setShowErrorMessage(
                    res?.error || res?.message?.message || "Something went wrong"
                );
                if (format === "excel") excelExportInFlightRef.current = false;
            }
        } catch (error) {
            setOpenErrorSnackbar(true);
            handleopenCloseErrorSnackbar(true);
            setShowErrorMessage("Something went wrong");
            if (format === "excel") excelExportInFlightRef.current = false;
        }
    };

    const handleClickForCustomer = (event: React.MouseEvent<HTMLElement>) => {
        setCustomerAnchorEl(event.currentTarget);
    };

    const handleCloseForCustomer = () => {
        setCustomerAnchorEl(null);
    };

    const onSearchCustomerId = (searchText: any) => {
        setSearchTextByID(searchText);
        // getFSECustomerListData && getFSECustomerListData.data && getFSECustomerListData.data.length > 0 && getFSECustomerListData.data.map((item: any) => (
        //   console.log("__________________", item)
        // ))
        setCustomerId(getFSECustomerListData && getFSECustomerListData.data);
        if (searchText.length > 0) {
            const filteredIds = getFSECustomerListData && getFSECustomerListData.data && getFSECustomerListData.data.length > 0 && getFSECustomerListData.data.filter((sapId: any) => sapId.sapCustomerId.toLowerCase().includes(searchText.toLowerCase()) || sapId.name.toLowerCase().includes(searchText.toLowerCase()));
            setCustomerId(filteredIds);
        } else {
            setCustomerId(getFSECustomerListData && getFSECustomerListData.data);
        }
    };
    const paymentStatusOptions = [
        "All", "Due", "Completed"
    ];
    const validateSearch = () => {
        // Check start and end dates
        if (!startDate || !endDate) {
            handleopenCloseErrorSnackbar(true);
            setShowErrorMessage("Start Date and End Date are mandatory.");
            return false;
        }

        // Check customer selection for FSE or SRE or KAM roles
        if ((userRole === "sre" || userRole === "FSE" || userRole === "kam") && !selectedCustomerId) {
            handleopenCloseErrorSnackbar(true);
            setShowErrorMessage("Please select a Customer.");
            return false;
        }

        // All validations passed
        return true;
    };


    useEffect(() => {
        if (getFSECustomerListData?.data) {
            setAllCustomers(getFSECustomerListData.data);
            setCustomerId(getFSECustomerListData.data);
        }
    }, [getFSECustomerListData]);
    useEffect(() => {

        if (!filterByCustomer || filterByCustomer === 'All') {
            setCustomerId(allCustomers);
            return;
        }

        const typeMap: any = {
            Dealer: 'dealer',
            Workshop: 'workshop',
            Government: 'government',
            Fleet: 'fleet',
            'TPC Dealer': 'tpcdealer',
            'TBL Dealer': 'tbl dealer',
            'Int. Business': 'int. business',
        };

        const normalize = (val: string) =>
            val?.toLowerCase().replace(/\s/g, '');

        const selectedType = typeMap[filterByCustomer];

        const filtered = allCustomers.filter((item: any) =>
            normalize(item.customerTierType) === normalize(selectedType)
        );

        setCustomerId(filtered);

    }, [filterByCustomer, allCustomers]);
    useEffect(() => {
        setSelectedCustomerId('');
        setSelectedCustomerName('');
    }, [filterByCustomer]);

  
    const handleClickSapId = (
        event: any,
        name: string,
        sapCustomerId: string,
        customerTierType?: string
    ) => {
        setSelectedCustomerId(`${sapCustomerId} - ${name}`);
        if (customerTierType) {
            sessionStorage.setItem('customerTierType', customerTierType);
        }
    };


    // Format the date with day, month, year, hours, minutes, seconds, and timezone
    const [startDate, setstartDate] = useState<any>(null);
    const [endDate, setendDate] = useState<any>(null);


    const { profileDetails }: any = useSelector(
        (state: any) => state.profileDetails
    );

    const webApplicationLoginId: any = sessionStorage.getItem("webApplicationLoginId");
    const sapCustomerId = _.get(
        profileDetails,
        "data.data.basicInfo.sapCustomerId",
        ""
    );
    const userRole = sessionStorage.getItem('userType');
    const resetFilters = () => {
        setSearchTextByID("");
        setInvoiceSearch("");
        setSalesOrderSearch("");
        setSelectedCustomerId("");
        setstartDate("");
        setendDate("");
        setPaymentStatus("All");
        setReturnOrderList([]);
        setIsResetTriggered(true);
        setFilterByCustomer(sessionStorage.getItem('userType') === 'sre' ? "All" : '')
        sessionStorage.removeItem('customerTierType');
    };

    const fetchReturnOrderAPI = async () => {

        try {
            setLoading(true);
            const payload: any = {
                customers: [
                    {
                        customerNumber:
                            (selectedCustomerId
                                ? selectedCustomerId.split(" - ")[0]
                                : (userRole === 'FSE' || userRole === 'kam' || userRole === 'sre'
                                    ? undefined
                                    : sapCustomerId)
                            ) || "",

                    },
                ],
                invoices: [
                    {
                        invoiceNumber: invoiceSearch || "",
                    },
                ],
                salesDocuments: [
                    {
                        salesDocument: salesOrderSearch || "",
                    },
                ],
                paymentStatus: paymentStatus || "",

                sessionDetails: {
                    webApplicationLoginId,
                    clientIPAddress: sessionStorage.getItem('clientIp') || '',
                },
                fromDate: startDate || "",
                toDate: endDate || "",
                userType: userRole === 'FSE' ? "FSE" : userRole === 'kam' ? "kam" : userRole === 'sre' ? "sre" : "Customer",
            };

            // If a value is missing, replace with empty array
            if (!payload.customers[0].customerNumber) payload.customers = [];
            if (!payload.invoices[0].invoiceNumber) payload.invoices = [];
            if (!payload.salesDocuments[0].salesDocument) payload.salesDocuments = [];


            const responseData: any = await dispatch(getListOfDownloadInvoiceAPI(payload));
            const returnOrderResponse = Array.isArray(responseData?.data) ? responseData.data : [];
            setReturnOrderList(returnOrderResponse);
            setOpenErrorSnackbar(false);
            handleopenCloseErrorSnackbar(false);
            setShowErrorMessage(null);
            setSuccessMessage(responseData?.message?.message || "Invoice data fetched successfully");
            setOpenSnackbar(true);
            handleopenCloseSnackbar(true);
        } catch (error: any) {
            setOpenErrorSnackbar(true);
            handleopenCloseErrorSnackbar(true);
            setShowErrorMessage(error?.message || "Something went wrong");
        } finally {
            setLoading(false);
        }
    };

    const getInvoiceDetails = async (data: any) => {
        setLoading(true);
        const sessionDetails = {
            webApplicationLoginId: webApplicationLoginId,
            clientIPAddress: sessionStorage.getItem('clientIp'),
        };

        const payload = {
            searchByInvoice: true,
            invoiceNumber: (data?.invoiceNumber || "").replace(/^0+/, ""),
            orderNumber: data?.salesOrder || "",
            sessionDetails,
        };

        try {
            let responseData: any = await dispatch(getBillingDetails(payload));

            // Explicit API-level error (success: false) OR message.status === "E"
            if (
                responseData?.success === false ||
                responseData?.message?.status === "E" ||
                responseData?.status === 400
            ) {
                setOpenErrorSnackbar(true);
                handleopenCloseErrorSnackbar(true);
                setShowErrorMessage(
                    responseData?.error ||
                    responseData?.message?.message ||
                    "Something went wrong"
                );
                setLoading(false);
                return false; // signal failure — do not navigate
            }

            setOpenErrorSnackbar(false);
            handleopenCloseSnackbar(true);
            setSuccessMessage(responseData?.message?.message);
            setLoading(false);
            return true; // signal success — safe to navigate
        } catch (error: any) {
            setOpenErrorSnackbar(true);
            handleopenCloseErrorSnackbar(true);
            setShowErrorMessage(error?.message || "Something went wrong");
            setLoading(false);
            return false;
        }
    };

    useEffect(() => {
        const dataType = userRole === 'kam' ? 'customerListForKAM' : undefined;
        dispatch(getFSECustomerList(dataType));
    }, [dispatch]);



    const handleopenCloseSnackbar = (open?: any) => {
        setOpenSnackbar(open ? true : false);
    };

    const handleopenCloseErrorSnackbar = (open?: any) => {
        setOpenErrorSnackbar(open ? true : false);
    };




    return (
        <div className={classes.root}>
            {loading && <FullscreenLoader />}
            <Snackbar
                open={openSnackbar}
                message={successMessage}
                handleopenClose={() => {
                    handleopenCloseSnackbar(false);
                }}
            />
            <Snackbar
                open={openErrorSnackbar}
                type="error"
                message={showErrorMessage}
                handleopenClose={() => {
                    handleopenCloseErrorSnackbar(false);
                }}
            />
            <div className="d-flex align-items-center mt-2 mb-2">
                <h2 className="page-title">Search Invoice</h2>
                <div className="ml-auto">
                    <AnnouncementIcon />
                    <NotificationIcon />
                </div>
            </div>

            {/* Filter Card */}
            <div className="row mt-4">
                <div className="col-12">
                    <div className="cardCommon p-3 pt-4">
                        <h5 className="mb-3 font-weight-bold" style={{ color: 'black' }}>Search Invoice</h5>

                        <TextField
                            value={invoiceSearch}
                            onChange={(e) => setInvoiceSearch(e.target.value)}
                            size="small"
                            className="col-lg-4 common-input-font-size commonRoundedInputs searchField p-[12px] mr-2 mb-2"
                            label="Search by Invoice No."
                            variant="outlined"
                        />



                        <Tooltip
                            title="Maximum 31 days data can be tracked."
                            placement="top"
                        >
                            <div className="col-lg-4 d-inline-flex date-picker-50  mx-2 mb-2">

                                <DatePicker
                                    startDate={startDate}
                                    endDate={endDate}
                                    setstartDate={setstartDate}
                                    setendDate={setendDate}
                                    startDatePlaceholderText="From Date*"
                                    endDatePlaceholderText="To Date*"
                                    isEnableOnlyThirtyDays={true}
                                    onChange={(start: any, end: any) => {
                                        setstartDate(start);
                                        setendDate(end);
                                    }}
                                />
                            </div>
                        </Tooltip>
                        <TextField
                            value={salesOrderSearch}
                            onChange={(e) => setSalesOrderSearch(e.target.value)}
                            size="small"
                            className="col-lg-3 common-input-font-size commonRoundedInputs searchField p-[12px] searchField ml-2 mb-2"
                            label="Search by Sales Order No."
                            variant="outlined"
                        />



                        <div className="w-100 d-flex mt-2 ">
                            {sessionStorage.getItem('userType') === 'sre' && (
                                <div className="col-3 col-sm-6 col-md-3 col-lg-3 d-inline-flex pl-0 pr-0">
                                    <div className="col d-inline-flex pl-0 pr-0">
                                        <TextField
                                            id="kamList"
                                            select
                                            label="Filter By CustomerType"
                                            variant="outlined"
                                            className="commonRoundedInputs w-100 bd-highlight mr-2 mb-2"
                                            size="small"
                                            onChange={(e: any) => {
                                                setSelectedCustomerId('');
                                                setSelectedCustomerName('');
                                                setFilterByCustomer(e.target.value);
                                            }}
                                            SelectProps={{
                                                MenuProps: {
                                                    getContentAnchorEl: null,
                                                    anchorOrigin: {
                                                        vertical: "bottom",
                                                        horizontal: "left",
                                                    },
                                                    transformOrigin: {
                                                        vertical: "top",
                                                        horizontal: "left",
                                                    },
                                                },
                                            }}
                                            value={filterByCustomer}
                                        >
                                            {getCustomerFilterOptions('sreCustomerList')}
                                        </TextField>
                                    </div>
                                </div>
                            )}
                            {(userRole === "FSE" || userRole === "kam" || userRole === "sre") && (
                                <>
                                    <TextField
                                        id="customerId"
                                        variant="outlined"
                                        size="small"
                                        onClick={handleClickForCustomer}
                                        value={selectedCustomerId}
                                        label="Filter By Customer*"
                                        placeholder="Filter By Customer"
                                        className="col-lg-3 common-input-font-size commonRoundedInputs mb-2 mr-2"
                                        InputProps={{
                                            readOnly: true,
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <SearchIcon />
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                    {/* Dropdown menu */}
                                    <div>
                                        {/* Search input inside dropdown */}
                                        <Menu
                                            open={Boolean(customerAnchorEl)}
                                            anchorEl={customerAnchorEl}
                                            onClose={handleCloseForCustomer}
                                            getContentAnchorEl={null}
                                            MenuListProps={{
                                                autoFocusItem: false,
                                            }}
                                            anchorOrigin={{
                                                vertical: 'bottom',
                                                horizontal: 'left',
                                            }}
                                            transformOrigin={{
                                                vertical: 'top',
                                                horizontal: 'left',
                                            }}
                                            PaperProps={{
                                                style: {
                                                    width: "auto",
                                                    maxHeight: 300,
                                                    overflowY: "auto",
                                                    whiteSpace: "nowrap",
                                                },
                                            }}
                                        >
                                            <Box
                                                px={2}
                                                py={1}
                                                position="sticky"
                                                top={0}
                                                bgcolor="white"
                                                zIndex={1}
                                                m={2}
                                            >
                                                <TextField
                                                    autoFocus
                                                    fullWidth
                                                    size="small"
                                                    placeholder="Search Customer(s)"
                                                    value={searchTextByID}
                                                    onChange={(e) => setSearchTextByID(e.target.value)}
                                                    className="ml-n2 mt-1"
                                                    variant="outlined"
                                                />
                                            </Box>
                                            {/* Customer list */}
                                            {customerId && customerId
                                                .filter(
                                                    (c) =>
                                                        c.name.toLowerCase().includes(searchTextByID.toLowerCase()) ||
                                                        c.sapCustomerId.includes(searchTextByID)
                                                )
                                                .map((sapId: any, i: any) => (
                                                    <Grid key={sapId.sapCustomerId} container className="border-bottom">
                                                        <MenuItem
                                                            value={sapId.sapCustomerId}
                                                            onClick={(event) => {
                                                                handleClickSapId(event, sapId.name, sapId.sapCustomerId, sapId.customerTierType);
                                                                handleCloseForCustomer();
                                                            }}
                                                        >
                                                            <ListItemText primary={sapId.sapCustomerId} />
                                                            <p className="px-5">{sapId.name}</p>
                                                        </MenuItem>
                                                    </Grid>
                                                ))}

                                            {/* No results */}
                                            {customerId && customerId.length === 0 && (
                                                <Grid container>
                                                    <div className="d-flex justify-content-center text-center mx-auto">
                                                        No Customers found.
                                                    </div>
                                                </Grid>
                                            )}

                                        </Menu>
                                    </div>
                                </>
                            )}


                            <div
                                className={"col-3 col-sm-4 col-md-3 col-lg-3  pl-0 "}
                            >
                                <FormControl
                                    size="small"
                                    variant="outlined"
                                    className="rounded-input-dealer w-100"
                                >      <InputLabel id="status-label">Payment status</InputLabel>
                                    <Select
                                        labelId="status-label"
                                        id="status"
                                        value={paymentStatus}
                                        onChange={(e) => setPaymentStatus(e.target.value as string)}
                                        label="Payment status"
                                        MenuProps={{
                                            disablePortal: true,
                                            anchorOrigin: {
                                                vertical: "bottom",
                                                horizontal: "left",
                                            },
                                            transformOrigin: {
                                                vertical: "top",
                                                horizontal: "left",
                                            },
                                            getContentAnchorEl: null,
                                        }}
                                    >
                                        {paymentStatusOptions.map((s) => (
                                            <MenuItem key={s} value={s}>
                                                {s}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </div>


                            <div className="d-flex">
                                <Button
                                    variant="contained"
                                    className="cancel-button font-size-11 pl-0 ml-3  mr-2 mb-2"
                                    size="small"
                                    onClick={resetFilters}
                                >
                                    Clear
                                </Button>
                                <Button
                                    className="font-size-11 pl-0 addOrderEnqButton mr-2  mb-2"
                                    size="large"
                                    variant="contained"
                                    color="primary"
                                    onClick={() => {
                                        if (validateSearch()) {
                                            fetchReturnOrderAPI();
                                        }
                                    }}

                                >
                                    Search
                                </Button>

                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div className={classes.invoiceHeader}>
                <div className={classes.invoiceInfo}>
                    <h5 className={`${classes.pageSub} pt-2 pb-2`}>List of all Invoices</h5>
                </div>
                {(userRole === "FSE" || userRole === "kam" || userRole === "sre") && (
                    <div className="legendItem ml-auto">
                        <span className="dot"></span>
                        <span className="legendItemLabel px-1">SAP Order</span>
                    </div>
                )}

            </div>

            {/* Table */}
            <div className={classes.tableContainer}>
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead className={classes.tableHeader}>
                            <TableRow>
                                <TableCell className={classes.tableHeadSmall}></TableCell>
                                <TableCell className={classes.headerCell}>
                                    <div className="mt-3 pt-0 pb-0"> Invoice No.</div>
                                    <div className={classes.subHeaderText}>Date</div>
                                </TableCell>
                                <TableCell className={classes.headerCell}>
                                    Sales Order No.
                                </TableCell>
                                <TableCell className={classes.headerCell}>
                                    <div className="mt-3 pt-0 pb-0">Invoice Total</div>
                                    <div className={classes.subHeaderText}>(Incl. of VAT)</div>
                                </TableCell>
                                <TableCell className={classes.headerCell}>
                                    Created by
                                </TableCell>
                                <TableCell className={classes.headerCell}>Payment Status</TableCell>
                                <TableCell className={classes.headerCell}>Action</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {returnOrderList?.length > 0 ? (returnOrderList?.map((row, index) => (
                                <TableRow key={index}>
                                    <TableCell className={classes.tableHeadSmall1}>
                                        {(userRole === "FSE" || userRole === "kam" || userRole === "sre") &&
                                            row.tradepointEnquiryFlag !== "X" && (
                                                <span className="dot"></span>
                                            )
                                        }
                                    </TableCell>

                                    <TableCell
                                        className={classes.bodyCell}
                                    >
                                        <div className="mt-3 pt-0 pb-0">{row.billingDocument}</div>
                                        <div className={classes.subHeaderText1}>
                                            {moment(row.invoiceDate).tz('Asia/Dubai').format('YYYY-MM-DD')}
                                        </div>

                                    </TableCell>
                                    <TableCell className={classes.bodyCell}>
                                        {row.salesOrder}
                                    </TableCell>
                                    <TableCell className={classes.bodyCell}>
                                        {new Intl.NumberFormat('en-AE', {
                                            style: 'currency',
                                            currency: 'AED',
                                            minimumFractionDigits: 0,
                                            maximumFractionDigits: 2
                                        }).format(row.netValue)}
                                    </TableCell>

                                    <TableCell className={classes.bodyCell}>
                                        <div className={row.internalUser ? "mt-3 pt-0 pb-0" : ""}>{row.createdBy}</div>
                                        {row.internalUser && (
                                            <div className={classes.subHeaderText1}>
                                                ({row.internalUser})
                                            </div>
                                        )}
                                    </TableCell>
                                    <TableCell className={classes.bodyCell}>
                                        <Typography
                                            style={{
                                                color: row.paymentStatus === 'Completed' ? 'green' : 'orange',
                                                fontWeight: 600,
                                            }}
                                        >
                                            {row.paymentStatus}
                                        </Typography>

                                    </TableCell>
                                    <TableCell >
                                        {!(profileDetails?.data?.data?.accessParameter?.featureAccessibility?.find(
                                            (f: { featureCode: string; value: boolean; label: string }) => f.featureCode === 'DOWNLOAD_PDF'
                                        )?.value === false &&
                                            profileDetails?.data?.data?.accessParameter?.featureAccessibility?.find(
                                                (f: { featureCode: string; value: boolean; label: string }) => f.featureCode === 'DOWNLOAD_EXCEL'
                                            )?.value === false) && (
                                                <>
                                                    <Tooltip title="Download Invoice">
                                                        <IconButton
                                                            size="small"
                                                            style={{
                                                                cursor: "pointer",
                                                                color: "#1A9FE0",
                                                                display: "inline-flex",
                                                                paddingLeft: 0,
                                                            }}
                                                            onClick={(e) => handleClick(e, row.billingDocument, row.salesOrder)}
                                                        >
                                                            <GetAppIcon fontSize="inherit" />
                                                        </IconButton>
                                                    </Tooltip>


                                                    <Menu
                                                        anchorEl={anchorEl}
                                                        keepMounted
                                                        open={Boolean(anchorEl)}
                                                        onClose={handleClose}
                                                        PaperProps={{
                                                            style: {
                                                                backgroundColor: 'white',
                                                                borderRadius: '8px',
                                                                boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                                                                border: '1px solid #f3f4f6',
                                                                minWidth: '180px'
                                                            }
                                                        }}
                                                    >
                                                        {/* Export to Excel */}
                                                        {profileDetails?.data?.data?.accessParameter?.featureAccessibility?.find(
                                                            (f: { featureCode: string; value: boolean; label: string }) => f.featureCode === 'DOWNLOAD_EXCEL'
                                                        )?.value !== false && (
                                                                <MenuItem
                                                                    onClick={() => {
                                                                        exportExcel(selectedBillingDocument, selectedSalesOrder);
                                                                        handleClose();
                                                                    }}
                                                                    style={{
                                                                        color: '#1A9FE0',
                                                                        backgroundColor: 'white',
                                                                        fontWeight: 500,
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        gap: '8px',
                                                                        minHeight: '44px',
                                                                        boxShadow: '0 1px 1px rgba(0,0,0,0.02)',
                                                                        margin: '2px 4px',
                                                                        borderRadius: '4px',
                                                                    }}
                                                                >
                                                                    <GetAppIcon fontSize="small" style={{ color: '#1A9FE0' }} />
                                                                    Export to Excel
                                                                </MenuItem>
                                                            )}

                                                        {!(profileDetails?.data?.data?.accessParameter?.featureAccessibility?.find(
                                                            (f: { featureCode: string; value: boolean; label: string }) => f.featureCode === 'DOWNLOAD_PDF'
                                                        )?.value === false &&
                                                            profileDetails?.data?.data?.accessParameter?.featureAccessibility?.find(
                                                                (f: { featureCode: string; value: boolean; label: string }) => f.featureCode === 'DOWNLOAD_EXCEL'
                                                            )?.value === false) && <div style={{
                                                                height: '1px',
                                                                backgroundColor: '#e5e7eb',
                                                                margin: '4px 12px'
                                                            }} />}

                                                        {/* Export to PDF */}
                                                        {profileDetails?.data?.data?.accessParameter?.featureAccessibility?.find(
                                                            (f: { featureCode: string; value: boolean; label: string }) => f.featureCode === 'DOWNLOAD_PDF'
                                                        )?.value !== false && (
                                                                <MenuItem
                                                                    onClick={() => {
                                                                        exportData(selectedBillingDocument, "pdf", selectedSalesOrder);
                                                                        handleClose();
                                                                    }}
                                                                    style={{
                                                                        color: '#1A9FE0',
                                                                        backgroundColor: 'white',
                                                                        fontWeight: 500,
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        gap: '8px',
                                                                        minHeight: '44px',
                                                                        boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
                                                                        margin: '2px 4px',
                                                                        borderRadius: '4px',
                                                                    }}
                                                                >
                                                                    <GetAppIcon fontSize="small" style={{ color: '#1A9FE0' }} />
                                                                    Export to PDF
                                                                </MenuItem>
                                                            )}
                                                    </Menu>
                                                </>

                                            )}
                                        {userRole !== "kam" && (
                                            <Tooltip
                                                title={"View Invoice details / Request a Return"}
                                                placement="top"
                                            >

                                                <span>
                                                    <IconButton
                                                        size="small"
                                                        style={{
                                                            cursor: "pointer",
                                                            color: "#1A9FE0",
                                                            display: "inline-flex",
                                                        }}
                                                        onClick={async () => {
                                                            const invoiceDate = moment(row.invoiceDate).tz("Asia/Dubai").format("DD MMM YYYY");

                                                            sessionStorage.setItem("InoviceDate", invoiceDate);
                                                            sessionStorage.setItem("searchByInvoice", "true");

                                                            const isSuccess = await getInvoiceDetails({
                                                                invoiceNumber: row.billingDocument,
                                                                salesOrder: row.salesOrder,
                                                            });

                                                            if (isSuccess) {
                                                                history.push("/viewinvoice");
                                                            }
                                                        }}
                                                    >
                                                        <VisibilityIcon fontSize="inherit" />

                                                    </IconButton>
                                                </span>
                                            </Tooltip>)}

                                    </TableCell>



                                </TableRow>
                            ))) : (<TableRow>
                                <TableCell
                                    colSpan={10}
                                    align="center"
                                    className={classes.bodyCell}
                                >
                                    No Invoice found.
                                </TableCell>
                            </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>

            </div>


        </div>
    );
}